var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('a',{class:_vm.btnClass,attrs:{"href":_vm.urlGenerator(_vm.url)}},[_vm._v(_vm._s(_vm.title))]):_c('button',{class:_vm.btnClass,on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }